import { useState, useEffect } from "react";

import { getDoc, serverTimestamp, increment } from "firebase/firestore";
import { getBatch, getRef } from "lib/firebase";
import { useSetRecoilState } from "recoil";
import { userState } from "pages/_app";
import { createNotif } from "lib/createNotif";
import { sendNotifMail } from "lib/sendEmail";

import { CurrentUser } from "lib/type";

let isChangingFollow = false;

export const useFollow = (author: CurrentUser, user: CurrentUser) => {
  const [isPast, setIsPast] = useState(false);
  useEffect(() => {
    if (!author || !user) return;
    const checkFollowed = async () => {
      const followerPath = `${author.uid}/followerUsers/${user.uid}`;
      const followerRef = getRef("users", followerPath);
      const followerDoc = await getDoc(followerRef).catch((err) => {
        console.log(err);
        alert("フォロー情報の取得に失敗しました。");
        return null;
      });
      if (!followerDoc) return;
      setIsPast(followerDoc.exists() ? true : false);
    };
    checkFollowed();
  }, [author, user]);

  const [isFollowChecking, setIsFollowChecking] = useState(true);
  const [isFollowing, setIsFollowing] = useState<boolean>();
  useEffect(() => {
    if (!author || !user) return setIsFollowChecking(false);
    const loadFollowing = async () => {
      const followingPath = `${user.uid}/followeeUsers/${author.uid}`;
      const followingRef = getRef("users", followingPath);
      const followingDoc = await getDoc(followingRef).catch((err) => {
        console.log(err);
        alert("フォロー情報の取得に失敗しました。");
        return null;
      });
      if (!followingDoc) return setIsFollowChecking(false);
      setIsFollowing(followingDoc.exists() ? true : false);
      setIsFollowChecking(false);
    };
    loadFollowing();
  }, [author, user]);

  const setUser = useSetRecoilState(userState);
  const changeFollow = async () => {
    if (!author || !user || isChangingFollow || user.uid === author.uid) return;
    isChangingFollow = true;
    const batch = getBatch();
    const authorRef = getRef("users", author.uid);
    batch.update(authorRef, {
      followerCount: isFollowing ? increment(-1) : increment(1),
    });
    const myFollowingRef = getRef(
      "users",
      `${user.uid}/followeeUsers/${author.uid}`
    );
    if (!isFollowing) {
      const authorFollowerRef = getRef(
        "users",
        `${author.uid}/followerUsers/${user.uid}`
      );
      batch.set(authorFollowerRef, {
        followeeUid: author.uid,
        followerUid: user.uid,
        createdAt: serverTimestamp(),
      });
      batch.set(myFollowingRef, {
        followeeUid: author.uid,
        followerUid: user.uid,
        createdAt: serverTimestamp(),
      });
    } else {
      batch.delete(myFollowingRef);
    }
    if (isPast === false && user.uid !== author.uid)
      await createNotif("follow", batch, { id: "", title: "" }, user, author);
    batch
      .commit()
      .then(async () => {
        setIsFollowing(isFollowing ? false : true);
        setUser({
          ...user,
          totalLikeCount: isFollowing
            ? user.followerCount - 1
            : user.followerCount + 1,
        });
        if (author.uid !== user.uid && isPast === false && author.isSendNotif)
          sendNotifMail(author, user, "follow");
      })
      .catch((err) => {
        console.log(err);
        alert("フォローに失敗しました。");
      });
    isChangingFollow = false;
  };

  return { isFollowChecking, isFollowing, changeFollow };
};
